import React, { useState, useEffect } from 'react';
import { Button, Snackbar, SnackbarContent } from '@mui/material';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';

const UpdateBanner = () => {
    const [reg, setReg] = useState(null);

    useEffect(() => {
        const handler = (e) => setReg(e.detail.reg);
        window.addEventListener('swUpdateReady', handler);
        return () => window.removeEventListener('swUpdateReady', handler);
    }, []);

    const handleUpdate = () => {
        if (reg && reg.waiting) {
            // New SW is waiting — tell it to activate, then reload on controllerchange
            navigator.serviceWorker.addEventListener('controllerchange', () => {
                window.location.reload();
            });
            reg.waiting.postMessage('SKIP_WAITING');
        } else {
            // New SW already active (e.g. activated before user tapped Update)
            window.location.reload();
        }
    };

    return (
        <Snackbar
            open={Boolean(reg)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            sx={{ mb: { xs: 8, md: 2 } }}
        >
            <SnackbarContent
                message={
                    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <SystemUpdateAltIcon fontSize="small" />
                        A new version is available
                    </span>
                }
                action={
                    <Button color="primary" variant="contained" size="small" onClick={handleUpdate}>
                        Update
                    </Button>
                }
                sx={{ bgcolor: 'grey.900', color: '#fff' }}
            />
        </Snackbar>
    );
};

export default UpdateBanner;
